"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = require("../Grid");

var _Constant = require("../../Constant");

var _ = require("./");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    padding: 0;\n    max-width: 100%;\n\n    @media print, screen and (min-width: ", "px) {\n      flex-basis: 75%;\n      align-self: stretch;\n    }\n\n    > div:first-child {\n      @media print, screen and (max-width: ", "px) and (min-height: 480px) {\n        margin-top: 55px;\n        padding: 0 26px;\n      }\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    @media print, screen and (max-width: ", "px) {\n      padding: 0;\n      width: 100%;\n      height: 55px;\n      margin-left: -8px;\n      margin-right: -8px;\n    }\n\n    /* The top nav is not fixed on small devices in landscape mode or when zoomed in */\n    @media print, screen and (max-width: ", "px) and (min-height: 480px) {\n      margin-left: 0;\n      margin-right: 0;\n      position: fixed;\n      top: 0;\n      left: 0;\n      z-index: 999;\n    }\n\n    @media print, screen and (min-width: ", "px) {\n      max-width: 360px;\n      flex-basis: 25%;\n      min-height: 100%;\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  && {\n    @media print, screen and (min-height: 480px) {\n      flex-wrap: nowrap;\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    padding-left: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = (0, _styledComponents.default)(_Grid.Container)(_templateObject(), _Constant.Width.LG);
/* The top nav is not fixed on small devices in landscape mode or when zoomed in */

/* Row content needs to wrap if the top nav is not fixed */

var Row = (0, _styledComponents.default)(_Grid.Row)(_templateObject2());
var SidebarCol = (0, _styledComponents.default)(_Grid.Col)(_templateObject3(), _Constant.Width.MD - 1, _Constant.Width.MD - 1, _Constant.Width.MD);
var MainCol = (0, _styledComponents.default)(_Grid.Col)(_templateObject4(), _Constant.Width.MD, _Constant.Width.MD - 1);

var TwoColumnLayout = function TwoColumnLayout(_ref) {
  var renderSidebar = _ref.renderSidebar,
      renderMainContent = _ref.renderMainContent,
      renderBanner = _ref.renderBanner,
      phoneNumber = _ref.phoneNumber,
      isRegistration = _ref.isRegistration,
      linkRoute = _ref.linkRoute,
      linkText = _ref.linkText,
      handleRegister = _ref.handleRegister,
      className = _ref.className,
      containerPadding = _ref.containerPadding,
      props = (0, _objectWithoutProperties2.default)(_ref, ["renderSidebar", "renderMainContent", "renderBanner", "phoneNumber", "isRegistration", "linkRoute", "linkText", "handleRegister", "className", "containerPadding"]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    containerPadding: containerPadding,
    className: className
  }, /*#__PURE__*/_react.default.createElement(Row, null, /*#__PURE__*/_react.default.createElement(SidebarCol, null, /*#__PURE__*/_react.default.createElement(_.TwoColumnSidebar, (0, _extends2.default)({
    render: renderSidebar,
    phoneNumber: phoneNumber
  }, props))), /*#__PURE__*/_react.default.createElement(MainCol, null, renderBanner(), /*#__PURE__*/_react.default.createElement(_.TwoColumnMainContent, (0, _extends2.default)({
    render: renderMainContent,
    phoneNumber: phoneNumber,
    isRegistration: isRegistration,
    linkText: linkText,
    linkRoute: linkRoute,
    handleRegister: handleRegister
  }, props)))));
};

TwoColumnLayout.propTypes = {
  handleRegister: _propTypes.default.func,
  renderSidebar: _propTypes.default.func,
  renderMainContent: _propTypes.default.func,
  renderBanner: _propTypes.default.func,
  menuList: _propTypes.default.arrayOf(_propTypes.default.node),
  cta: _propTypes.default.node,
  phoneNumber: _propTypes.default.string,
  isRegistration: _propTypes.default.bool,
  isLogin: _propTypes.default.bool,
  linkRoute: _propTypes.default.string,
  linkText: _propTypes.default.string,
  contentMaxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  containerPadding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  fillContent: _propTypes.default.bool,
  className: _propTypes.default.string
};
TwoColumnLayout.defaultProps = {
  handleRegister: function handleRegister() {},
  renderSidebar: function renderSidebar() {
    return null;
  },
  renderMainContent: function renderMainContent() {
    return null;
  },
  renderBanner: function renderBanner() {
    return null;
  },
  menuList: [],
  cta: null,
  phoneNumber: '1-888-819-6388',
  isRegistration: false,
  isLogin: false,
  linkRoute: null,
  linkText: null,
  contentMaxWidth: undefined,
  fillContent: false,
  className: '',
  containerPadding: 15
};
var _default = TwoColumnLayout;
exports.default = _default;